import combineReducersNamed from 'common/src/app/util/reducers/combineReducersNamed';
import staticContent from 'common/src/app/reducers/staticContentReducer';

export default combineReducersNamed({
  staticContent,
});
